import * as React from 'react';
import styles from './index.less';
import { Popover, Space, Switch } from 'antd';
import Policies from './Policies';
import Viewports from './Viewports';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, ExhibitInfoPageModelState } from '@/models/connect';
import {
  ChangeAction,
  ChangeVersionAction,
  FetchInfoAction,
  OnMountPageAction,
  UpdateBaseInfoAction,
  OnSave_Side_ExhibitIntroduction_Action,
  OnSync_Options_Action,
} from '@/models/exhibitInfoPage';
import FTooltip from '@/components/FTooltip';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import { onlineExhibit } from '@/utils/nodeTools';
import { fOnOffFeedback } from '@/components/fOnOffFeedback';
import FCoverImage from '@/components/FCoverImage';
import fMessage from '@/components/fMessage';
import FResourceCard from '@/components/FResourceCard';
import FLoadingTip from '@/components/FLoadingTip';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import { useParams } from 'react-router-dom';
import useUrlState from '@/hooks/useUrlState';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import ResourceLabelsCard from '@/components/FResourceLabelsCard';
import IntroductionCard from '@/components/FIntroductionCard';
import fEditLabelsDrawer from '@/components/fEditLabelsDrawer';
import fEditIntroductionDrawer from '@/components/fEditIntroductionDrawer';
import FIcons from '@/components/FIcons';
import FCoverImageEditor from '@/components/FCoverImageEditor';
import FGlobalLoading from '@/components/FGlobalLoading';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
import FDropdown2 from '@/components/FDropdown2';
import FThemeDependencyPlugins from '@/components/FThemeDependencyPlugins';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';

interface PresentableProps {
  dispatch: Dispatch;
  exhibitInfoPage: ExhibitInfoPageModelState;
}

function Presentable({ dispatch, exhibitInfoPage }: PresentableProps) {
  const params = useParams<{ id: string }>();
  const refPromise = React.useRef<Promise<void> | null>(null);

  const [urlState] = useUrlState<{
    openAuthDrawer?: string;
    showMoreSetting?: string;
  }>();

  const [$authorizationUpdate, set$authorizationUpdate, get$authorizationUpdate] =
    FUtil.Hook.useGetState<number>(0);

  const [$globalLoading, set$globalLoading, get$globalLoading] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(() => {
    dispatch<OnMountPageAction>({
      type: 'exhibitInfoPage/onMountPage',
      payload: {
        exhibitID: params.id!,
      },
    });

    dispatch<ChangeAction>({
      type: 'exhibitInfoPage/change',
      payload: {
        side_SettingUnfold: urlState.showMoreSetting === 'true',
      },
    });
  });

  async function activateTheme() {
    const res1: boolean = await fPromiseModalConfirm({
      title: '提示',
      // icon: <div />,
      description: FI18n.i18nNext.t('msg_change_theme_confirm', {
        ThemeName: exhibitInfoPage.exhibit_Name,
      }),
      okText: FI18n.i18nNext.t('btn_activate_theme'),
      cancelText: FI18n.i18nNext.t('keep_current_theme'),
    });

    if (!res1) {
      return;
    }

    await onlineExhibit({
      exhibit_ID: exhibitInfoPage.exhibit_ID,
      async onStartOnline() {
        set$globalLoading(true);
      },
      async onEndOnline() {
        set$globalLoading(false);
        await refPromise.current;
      },
    });

    fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
      value: false,
      effectiveImmediately: true,
      onlyNullish: false,
    });

    dispatch<FetchInfoAction>({
      type: 'exhibitInfoPage/fetchInfo',
    });
  }

  if (exhibitInfoPage.pageLoading) {
    return <FLoadingTip height={'calc(100vh - 70px)'} />;
  }

  return (
    <>
      <div className={styles.Presentable}>
        <div className={styles.content}>
          <div style={{ height: 40 }} />
          <Space size={5}>
            <FComponentsLib.FTextBtn
              onClick={() => {
                window.open(
                  FUtil.LinkTo.nodeManagement({
                    nodeID: exhibitInfoPage.exhibit_BelongNode_ID,
                  }),
                );
              }}
              style={{ fontWeight: 600 }}
              type='default'
            >
              <FComponentsLib.FContentText
                type={'negative'}
                text={
                  exhibitInfoPage.exhibit_BelongNode_Title ||
                  exhibitInfoPage.exhibit_BelongNode_Name
                }
                style={{ fontWeight: 600, maxWidth: 200 }}
                singleRow
              />
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FContentText type={'negative'} text={'>'} style={{ fontWeight: 600 }} />
            <FComponentsLib.FContentText
              type={'highlight'}
              text={exhibitInfoPage.exhibit_Title || exhibitInfoPage.exhibit_Name}
              style={{
                maxWidth: 600,
              }}
              singleRow
            />
          </Space>
          <div style={{ height: 40 }} />

          <div className={styles.onlineSwitch}>
            {!exhibitInfoPage.exhibit_IsAuth && (
              <Space size={5}>
                <FIcons.FWarning style={{ fontSize: 16 }} />
                <FComponentsLib.FContentText type={'additional2'} style={{ color: '#222' }}>
                  {exhibitInfoPage.exhibit_AuthErrorText}
                </FComponentsLib.FContentText>
              </Space>
            )}

            {exhibitInfoPage.exhibit_IsAuth && (
              <>
                {exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                  <>
                    <FComponentsLib.FContentText
                      text={exhibitInfoPage.exhibit_Online ? '主题已激活' : '主题未激活'}
                      type={'normal'}
                      style={{ fontWeight: 600 }}
                    />
                  </>
                )}

                {!exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                  <>
                    <FComponentsLib.FContentText
                      text={
                        exhibitInfoPage.exhibit_Online
                          ? // ? '展品已上架'
                            FI18n.i18nNext.t('edit_exhibit_status_availableforauth')
                          : // : '展品未上架'}
                            FI18n.i18nNext.t('edit_exhibit_status_pendingauth')
                      }
                      type={'normal'}
                      style={{ fontWeight: 600 }}
                    />
                  </>
                )}
              </>
            )}

            <FHotspotTooltip
              id={'exhibitDetailPage.onlineSwitch'}
              style={{ left: -42, top: -4 }}
              text={FI18n.i18nNext.tAuto('hotpots_exhibit_toggle_exhibit')}
            >
              <Space size={20}>
                {exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                  <>
                    {exhibitInfoPage.exhibit_Online && (
                      <div
                        style={{
                          backgroundColor: '#42C28C',
                          borderRadius: 12,
                          lineHeight: '18px',
                          color: 'white',
                          fontSize: 12,
                          padding: '3px 10px',
                        }}
                      >
                        {FI18n.i18nNext.tAuto('theme_state_active')}
                      </div>
                    )}
                    {!exhibitInfoPage.exhibit_Online && (
                      <>
                        <FComponentsLib.FContentText
                          type={'highlight'}
                          text={FI18n.i18nNext.t('toggle_activate_theme')}
                        />
                        <Switch
                          disabled={
                            !exhibitInfoPage.exhibit_IsAuth && !exhibitInfoPage.exhibit_Online
                          }
                          checked={exhibitInfoPage.exhibit_Online}
                          className={styles.CustomSwitch}
                          onChange={async () => {
                            activateTheme();
                          }}
                        />
                      </>
                    )}
                  </>
                )}

                {!exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                  <>
                    <FComponentsLib.FContentText
                      type={'highlight'}
                      text={FI18n.i18nNext.t('switch_set_exhibit_avaliable')}
                    />
                    <Switch
                      disabled={!exhibitInfoPage.exhibit_IsAuth && !exhibitInfoPage.exhibit_Online}
                      checked={exhibitInfoPage.exhibit_Online}
                      className={styles.CustomSwitch}
                      onChange={async (checked) => {
                        if (checked) {
                          await onlineExhibit({
                            exhibit_ID: exhibitInfoPage.exhibit_ID,
                          });
                        } else {
                          const confirm: boolean = await fPromiseModalConfirm({
                            // title: '下架展品',
                            // description: '',
                            title: '提示',
                            description:
                              // 下架后，其它用户将无法签约该展品，确认要下架吗？
                              FI18n.i18nNext.t('confirm_msg_remove_exhibits_from_auth'),
                            okText: FI18n.i18nNext.t('btn_remove_exhibits_from_auth'),
                            promptKey_localStorage: 'offlineExhibit',
                          });

                          if (confirm) {
                            const params2: Parameters<
                              typeof FServiceAPI.Exhibit.presentablesOnlineStatus
                            >[0] = {
                              presentableId: exhibitInfoPage.exhibit_ID,
                              onlineStatus: 0,
                            };
                            await FServiceAPI.Exhibit.presentablesOnlineStatus(params2);
                            fOnOffFeedback({
                              state: 'off',
                              message: FI18n.i18nNext.t('remove_resource_from_auth_msg_done'),
                            });
                          }
                        }
                        fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
                          value: false,
                          effectiveImmediately: true,
                          onlyNullish: false,
                        });
                        dispatch<FetchInfoAction>({
                          type: 'exhibitInfoPage/fetchInfo',
                        });
                      }}
                    />
                  </>
                )}
              </Space>
            </FHotspotTooltip>
          </div>

          <div style={{ height: 5 }} />
          {exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') === false && (
            <div className={styles.exhibitInfo}>
              <FCoverImageEditor
                src={exhibitInfoPage.exhibit_Cover || ''}
                width={260}
                onChange={(url) => {
                  dispatch<UpdateBaseInfoAction>({
                    type: 'exhibitInfoPage/updateBaseInfo',
                    payload: {
                      exhibit_Cover: url,
                    },
                  });
                }}
              />

              <div className={styles.info}>
                <div>
                  <ExhibitTitleInput
                    value={exhibitInfoPage.side_ExhibitTitle}
                    onOK={(value) => {
                      dispatch<UpdateBaseInfoAction>({
                        type: 'exhibitInfoPage/updateBaseInfo',
                        payload: {
                          side_ExhibitTitle: value,
                        },
                      });
                    }}
                  />
                  <div style={{ height: 5 }} />
                  {exhibitInfoPage.exhibit_ResourceInfo && (
                    <>
                      <Space size={4}>
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          // text={'合集'}
                          text={exhibitInfoPage.exhibit_ResourceInfo.type.join('/')}
                          style={{ color: '#999' }}
                        />

                        <FComponentsLib.FContentText
                          type={'additional2'}
                          text={'|'}
                          style={{ color: '#999' }}
                        />

                        <FComponentsLib.FContentText
                          type={'additional2'}
                          // text={`展品标识：${exhibitInfoPage.exhibit_BelongNode_Name}/${exhibitInfoPage.exhibit_Name}`}
                          text={`${FI18n.i18nNext.t('edit_exhibit_exhibitauthid')}${
                            exhibitInfoPage.exhibit_BelongNode_Name
                          }/${exhibitInfoPage.exhibit_Name}`}
                          style={{ color: '#999', maxWidth: 200 }}
                          singleRow
                        />
                      </Space>
                      <div style={{ height: 5 }} />
                      <Space size={4}>
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          text={
                            // 来自于
                            FI18n.i18nNext.t('edit_exhibit_relative_article')
                          }
                          style={{ color: '#999' }}
                        />
                        <Popover
                          content={
                            <FResourceCard
                              key={exhibitInfoPage.exhibit_ResourceInfo.id}
                              resource={exhibitInfoPage.exhibit_ResourceInfo}
                              // className={styles.FResourceCard}
                              onClick={() => {
                                window.open(
                                  FUtil.LinkTo.resourceDetails({
                                    resourceID: exhibitInfoPage.exhibit_ResourceInfo?.id || '',
                                  }),
                                );
                              }}
                            />
                          }
                          title={null}
                          placement={'bottom'}
                          overlayClassName={styles.resourceCardPopover}
                        >
                          <div style={{ width: 'fit-content' }}>
                            <FComponentsLib.FTextBtn
                              type='default'
                              style={{ color: '#999' }}
                              onClick={() => {
                                window.open(
                                  FUtil.LinkTo.resourceDetails({
                                    resourceID: exhibitInfoPage.exhibit_ResourceInfo?.id || '',
                                  }),
                                );
                              }}
                            >
                              <FComponentsLib.FContentText
                                type={'additional2'}
                                style={{
                                  color: 'inherit',
                                  textDecoration: 'underline',
                                  maxWidth: 570,
                                }}
                                singleRow
                                text={exhibitInfoPage.exhibit_ResourceInfo?.name || ''}
                              />
                            </FComponentsLib.FTextBtn>
                          </div>
                        </Popover>
                      </Space>
                    </>
                  )}
                </div>
                <div style={{ height: 20 }} />
                <ResourceLabelsCard
                  labels={exhibitInfoPage.side_ExhibitTags}
                  onClick={async () => {
                    const result: null | string[] = await fEditLabelsDrawer({
                      labels: exhibitInfoPage.side_ExhibitTags,
                    });
                    if (result === null) {
                      return;
                    }

                    dispatch<UpdateBaseInfoAction>({
                      type: 'exhibitInfoPage/updateBaseInfo',
                      payload: {
                        side_ExhibitTags: result,
                      },
                    });
                  }}
                />
                <div style={{ height: 10 }} />
                <IntroductionCard
                  text={exhibitInfoPage.side_ExhibitIntroduction}
                  onClick={async () => {
                    const result: null | string = await fEditIntroductionDrawer({
                      text: exhibitInfoPage.side_ExhibitIntroduction,
                    });
                    if (result === null) {
                      return;
                    }

                    dispatch<OnSave_Side_ExhibitIntroduction_Action>({
                      type: 'exhibitInfoPage/onSave_Side_ExhibitIntroduction',
                      payload: {
                        value: result,
                      },
                    });
                  }}
                />
              </div>
            </div>
          )}

          {exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') === true && (
            <a
              className={styles.themeInfo}
              title={
                // 查看发行详情（hover 标题）
                FI18n.i18nNext.t('check_release_details')
              }
              onClick={() => {
                self.open(
                  FUtil.LinkTo.resourceDetails({
                    resourceID: exhibitInfoPage.exhibit_ResourceInfo?.id || '',
                  }),
                );
              }}
            >
              <div className={styles.themeCover}>
                <FCoverImage src={exhibitInfoPage.exhibit_ResourceInfo.cover} width={104} />
              </div>

              <div className={styles.themeDetail}>
                <div className={styles.themeTitle}>{exhibitInfoPage.exhibit_ResourceInfo.title}</div>
                <div className={styles.themeMeta}>
                  <img
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      border: '1px solid #E5E7EB',
                    }}
                    src={exhibitInfoPage.exhibit_ResourceInfo.useAvatar}
                    alt={''}
                  />
                  <FComponentsLib.FContentText
                    type={'additional2'}
                    text={exhibitInfoPage.exhibit_ResourceInfo.username}
                    style={{ color: '#999' }}
                  />
                  <span className={styles.themeMetaDivider} />
                  <FComponentsLib.FContentText
                    type={'additional2'}
                    text={exhibitInfoPage.exhibit_ResourceInfo.type.join('/')}
                    style={{ color: '#999' }}
                  />
                  <span className={styles.themeMetaDivider} />
                  <FComponentsLib.FContentText
                    type={'additional2'}
                    text={`更新时间${exhibitInfoPage.exhibit_ResourceInfo.updateDate}`}
                    style={{ color: '#999' }}
                  />
                  {!!exhibitInfoPage.side_Version && (
                    <>
                      <span className={styles.themeMetaDivider} />
                      <FComponentsLib.FContentText
                        type={'additional2'}
                        text={
                          // 展示版本（键名，与下方「展示版本」区块一致）
                          `${FI18n.i18nNext.t('edit_exhibit_version')}${
                            exhibitInfoPage.side_Version
                          }`
                        }
                        style={{ color: '#999' }}
                      />
                    </>
                  )}
                </div>
              </div>
            </a>
          )}

          <div style={{ height: 5 }} />
          <div className={styles.moreSettingBar}>
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12, color: '#2784ff' }}
              type='default'
              onClick={() => {
                dispatch<ChangeAction>({
                  type: 'exhibitInfoPage/change',
                  payload: {
                    side_SettingUnfold: !exhibitInfoPage.side_SettingUnfold,
                  },
                });
              }}
            >
              {exhibitInfoPage.side_SettingUnfold
                ? FI18n.i18nNext.tAuto('brr_resourcelisting_item_btn_showlesssetting')
                : FI18n.i18nNext.tAuto('edit_exhibit_moresetting_btn')}
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FContentText
              text={
                // 可以为资源文件添加可选配置，或进行依赖资源的声明
                FI18n.i18nNext.t('edit_exhibit_moresetting_info')
              }
              type={'negative'}
              style={{ fontSize: 12 }}
            />
          </div>

          {exhibitInfoPage.side_SettingUnfold && (
            <>
              <div style={{ height: 10 }} />
              <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    // text={'展示版本'}
                    text={FI18n.i18nNext.t('edit_exhibit_version')}
                    type={'highlight'}
                  />
                </div>
                <div style={{ height: 20 }} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <FDropdown2
                    autoArrow={false}
                    // getPopupContainer={() => ref_Root.current as HTMLElement}
                    menu={{
                      selectedKeys: [exhibitInfoPage.side_Version],
                      items: [...exhibitInfoPage.side_AllVersions].reverse().map((av) => {
                        return {
                          key: av,
                          label: <div style={{ minWidth: 80 }}>{av}</div>,
                        };
                      }),
                      onClick: (value) => {
                        dispatch<ChangeVersionAction>({
                          type: 'exhibitInfoPage/changeVersion',
                          payload: value.key,
                        });
                      },
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <FComponentsLib.FContentText
                        type={'highlight'}
                        text={exhibitInfoPage.side_Version}
                        style={{ fontSize: 12 }}
                      />
                      <div style={{ width: 20 }} />

                      <FComponentsLib.FTextBtn>
                        <FIcons.FSwap style={{ fontSize: 12 }} />
                      </FComponentsLib.FTextBtn>
                      <div style={{ width: 2 }} />
                      <FComponentsLib.FTextBtn style={{ fontSize: 12 }}>
                        {
                          // 切换展示版本
                          FI18n.i18nNext.tAuto('edit_exhibit_version_btn_changeversion')
                        }
                      </FComponentsLib.FTextBtn>
                    </div>
                  </FDropdown2>

                  <div style={{ width: 60 }} />
                  <FComponentsLib.FContentText
                    type={'highlight'}
                    // text={'自动更新到最新版本'}
                    text={FI18n.i18nNext.t('edit_exhibit_version_toggles_automaticupdate')}
                    style={{ fontSize: 12 }}
                  />
                  <div style={{ width: 20 }} />
                  <Switch
                    size='small'
                    defaultChecked
                    className={styles.smallSwitch}
                    checked={exhibitInfoPage.exhibit_autoUpdate}
                    onChange={async (checked) => {
                      const { ret, errCode, msg } = await FServiceAPI.Exhibit.updatePresentable({
                        presentableId: exhibitInfoPage.exhibit_ID,
                        // @ts-ignore
                        autoUpdateStatus: checked ? 1 : 0,
                      });

                      if (ret !== 0 || errCode !== 0) {
                        fMessage(msg, 'error');
                        return;
                      }

                      dispatch<ChangeAction>({
                        type: 'exhibitInfoPage/change',
                        payload: {
                          exhibit_autoUpdate: checked,
                        },
                      });
                    }}
                  />
                </div>
              </div>

              {[...exhibitInfoPage.side_RawProperties, ...exhibitInfoPage.side_BaseProperties]
                .length > 0 && (
                <>
                  <div style={{ height: 5 }} />
                  <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FComponentsLib.FContentText
                        // text={'基础属性'}
                        text={FI18n.i18nNext.t('edit_exhibit_resourceinfo')}
                        type={'highlight'}
                      />
                    </div>
                    <div style={{ height: 20 }} />
                    <FAttrsAndConfigs
                      dateSource={[
                        ...exhibitInfoPage.side_RawProperties,
                        ...exhibitInfoPage.side_BaseProperties,
                      ].map<IAttrsAndConfigsItem>((ba) => ({
                        key: ba.key,
                        name: ba.name,
                        description: ba.description,
                        value: ba.value,
                        configs: {
                          item_Deletable: false,
                          key_Editable: false,
                          name_Editable: false,
                          description_Editable: false,
                          value_Editable: false,
                        },
                      }))}
                      disabledKeys={[]}
                      disabledNames={[]}
                    />
                  </div>
                </>
              )}

              {exhibitInfoPage.inheritOptions.length > 0 && (
                <>
                  <div style={{ height: 5 }} />
                  <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FComponentsLib.FContentText
                        // text={'可选配置'}
                        text={FI18n.i18nNext.t('edit_exhibit_resourceoptions')}
                        type={'highlight'}
                      />
                    </div>

                    <div style={{ height: 10 }} />
                    <FAttrsAndConfigs
                      dateSource={exhibitInfoPage.inheritOptions.map<IAttrsAndConfigsItem>(
                        (io) => ({
                          key: io.key,
                          name: io.name,
                          description: io.description,
                          value: io.value,
                          configs: {
                            item_Deletable: false,
                            key_Editable: false,
                            name_Editable: false,
                            description_Editable: false,
                            value_Editable:
                              io.type === 'select'
                                ? {
                                    configEnum: {
                                      nullable: true,
                                      defaultValue: io.defaultValue,
                                      options: io.options,
                                    },
                                  }
                                : {
                                    configText: {
                                      nullable: true,
                                      defaultValue: io.defaultValue,
                                      minLength: 1,
                                      maxLength: 140,
                                    },
                                  },
                          },
                        }),
                      )}
                      disabledKeys={[]}
                      disabledNames={[]}
                      onChangeItem={async (oldData, newData, index, changedFields) => {
                        const inheritOptions: ExhibitInfoPageModelState['inheritOptions'] =
                          exhibitInfoPage.inheritOptions.map((io, io_index) => {
                            if (io_index === index) {
                              return {
                                ...io,
                                key: newData.key,
                                name: newData.name,
                                description: newData.description,
                                value: newData.value,
                              };
                            }
                            return io;
                          });

                        await dispatch<ChangeAction>({
                          type: 'exhibitInfoPage/change',
                          payload: {
                            inheritOptions: inheritOptions,
                          },
                        });

                        dispatch<OnSync_Options_Action>({
                          type: 'exhibitInfoPage/onSync_Options',
                          payload: {
                            successMessage: changedFields.includes('value')
                              ? FI18n.i18nNext.t('saved_successfully')
                              : undefined,
                          },
                        });
                      }}
                    />
                  </div>
                </>
              )}

              <div style={{ height: 5 }} />
              <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    // text={'自定义信息'}
                    text={FI18n.i18nNext.t('edit_exhibit_customdata')}
                    type={'highlight'}
                  />
                  {exhibitInfoPage.customOptions.length < 30 && (
                    <FComponentsLib.FTextBtn
                      style={{ fontSize: 12, color: '#2784ff', padding: 0, height: 'auto' }}
                      type='default'
                      onClick={async () => {
                        const dataSource: {
                          key: string;
                          name: string;
                          description: string;
                        } | null = await fResourcePropertyEditor3({
                          disabledKeys: [
                            ...exhibitInfoPage.side_RawProperties.map((ba) => ba.key),
                            ...exhibitInfoPage.side_BaseProperties.map((ba) => ba.key),
                            ...exhibitInfoPage.inheritOptions.map((io) => io.key),
                            ...exhibitInfoPage.customOptions.map((co) => co.key),
                          ],
                          disabledNames: [
                            ...exhibitInfoPage.side_RawProperties.map((ba) => ba.name),
                            ...exhibitInfoPage.side_BaseProperties.map((ba) => ba.name),
                            ...exhibitInfoPage.inheritOptions.map((io) => io.name),
                            ...exhibitInfoPage.customOptions.map((co) => co.name),
                          ],
                        });

                        if (!dataSource) {
                          return;
                        }

                        await dispatch<ChangeAction>({
                          type: 'exhibitInfoPage/change',
                          payload: {
                            customOptions: [
                              ...exhibitInfoPage.customOptions,
                              { ...dataSource, value: '' },
                            ],
                          },
                        });

                        await dispatch<OnSync_Options_Action>({
                          type: 'exhibitInfoPage/onSync_Options',
                        });
                      }}
                    >
                      {
                        // 添加自定义信息
                        FI18n.i18nNext.tAuto('edit_exhibit_btn_addcustomdata')
                      }
                    </FComponentsLib.FTextBtn>
                  )}
                </div>

                {
                  // info.customConfigurations.length === 0 && (<>
                  exhibitInfoPage.customOptions.length === 0 && (
                    <>
                      <div style={{ height: 10 }} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FComponentsLib.FContentText
                          // text={'自定义信息是资源在消费端展示时所需的配置信息，您可以根据需要添加。'}
                          text={FI18n.i18nNext.t('edit_exhibit_customdata_info')}
                          type={'additional2'}
                        />
                      </div>
                      <div style={{ height: 20 }} />
                    </>
                  )
                }

                {exhibitInfoPage.customOptions.length > 0 && (
                  <>
                    <div style={{ height: 20 }} />

                    <FAttrsAndConfigs
                      dateSource={exhibitInfoPage.customOptions.map((co) => ({
                        key: co.key,
                        name: co.name,
                        value: co.value,
                        description: co.description,
                        configs: {
                          item_Deletable: true,
                          key_Editable: true,
                          name_Editable: true,
                          description_Editable: true,
                          value_Editable: {
                            text: {
                              nullable: true,
                              minLength: 1,
                              maxLength: 140,
                            },
                          },
                        },
                      }))}
                      onChange={async (dataSource, changedFields) => {
                        await dispatch<ChangeAction>({
                          type: 'exhibitInfoPage/change',
                          payload: {
                            customOptions: dataSource.map((co) => ({
                              key: co.key,
                              name: co.name,
                              value: co.value,
                              description: co.description,
                            })),
                          },
                        });
                        await dispatch<OnSync_Options_Action>({
                          type: 'exhibitInfoPage/onSync_Options',
                          payload: {
                            successMessage: changedFields.includes('value')
                              ? FI18n.i18nNext.t('saved_successfully')
                              : undefined,
                          },
                        });
                      }}
                      disabledKeys={[
                        ...exhibitInfoPage.side_RawProperties.map((ba) => ba.key),
                        ...exhibitInfoPage.side_BaseProperties.map((ba) => ba.key),
                        ...exhibitInfoPage.inheritOptions.map((io) => io.key),
                        ...exhibitInfoPage.customOptions.map((co) => co.key),
                      ]}
                      disabledNames={[
                        ...exhibitInfoPage.side_RawProperties.map((ba) => ba.name),
                        ...exhibitInfoPage.side_BaseProperties.map((ba) => ba.name),
                        ...exhibitInfoPage.inheritOptions.map((io) => io.name),
                        ...exhibitInfoPage.customOptions.map((co) => co.name),
                      ]}
                    />
                  </>
                )}
              </div>

              {exhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                  <>
                    <div style={{ height: 5 }} />
                    <FThemeDependencyPlugins
                      exhibitPresentableId={exhibitInfoPage.exhibit_ID}
                      onAfterDependencyAttrsSave={() => {
                        dispatch<FetchInfoAction>({
                          type: 'exhibitInfoPage/fetchInfo',
                        });
                      }}
                      items={exhibitInfoPage.themeDependencyPresentables}
                    />
                  </>
                )}
            </>
          )}

          <div style={{ height: 15 }} />
          <Policies />

          <div style={{ height: 5 }} />
          <div className={styles.block}>
            {exhibitInfoPage.exhibit_ResourceInfo &&
              exhibitInfoPage.exhibit_BelongNode_ID !== -1 && (
                <FMicroAPP_Authorization
                  licenseeId={exhibitInfoPage.exhibit_BelongNode_ID}
                  mainAppType={'resourceInExhibit'}
                  depList={[
                    {
                      id: exhibitInfoPage.exhibit_ResourceInfo.id,
                      name: exhibitInfoPage.exhibit_ResourceInfo.name,
                      type: 'resource',
                      // versionRange?: string;
                    },
                  ]}
                  upcastList={[]}
                  autoOpenPendingDrawer={!!urlState.openAuthDrawer}
                  mount={() => {
                  }}
                  update={(value) => {
                    // if (get$authorizationUpdate() > 0) {
                    dispatch<FetchInfoAction>({
                      type: 'exhibitInfoPage/fetchInfo',
                    });
                    // }
                    set$authorizationUpdate(get$authorizationUpdate() + 1);
                  }}
                />
              )}
          </div>

          {exhibitInfoPage.graphShow && (
            <>
              <div style={{ height: 5 }} />
              <div className={styles.block}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    // text={'相关视图'}
                    text={FI18n.i18nNext.t('edit_exhibit_maps')}
                    type={'highlight'}
                  />
                </div>
                <div style={{ height: 10 }} />
                <Viewports />
              </div>
            </>
          )}

          <div style={{ height: 100 }} />
        </div>
      </div>

      <FGlobalLoading
        open={$globalLoading}
        onOpened={(promise) => {
          refPromise.current = promise;
        }}
        onClosed={() => {}}
      />
    </>
  );
}

export default connect(({ exhibitInfoPage }: ConnectState) => ({
  exhibitInfoPage,
}))(Presentable);

interface ExhibitTitleInputProps {
  value: string;

  onOK(value: string): void;
}

export function ExhibitTitleInput({ value, onOK }: ExhibitTitleInputProps) {
  const [$isEdit, set$isEdit, get$isEdit] = FUtil.Hook.useGetState<boolean>(false);
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);
  const [$valueError, set$valueError, get$valueError] = FUtil.Hook.useGetState<string>('');

  function onEdit() {
    set$isEdit(true);
    set$value(value);
  }

  if (!$isEdit) {
    return (
      <Space size={10}>
        {value === '' && (
          <>
            <FComponentsLib.FTextBtn
              onClick={() => {
                onEdit();
              }}
            >
              <FIcons.FAdd />
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FTextBtn
              onClick={() => {
                onEdit();
              }}
            >
              添加标题
            </FComponentsLib.FTextBtn>
          </>
        )}

        {value !== '' && (
          <>
            <FComponentsLib.FTitleText
              type={'h2'}
              text={value}
              style={{ overflowWrap: 'anywhere', fontWeight: 600 }}
            />
            <FTooltip title={'编辑'}>
              <div>
                <FComponentsLib.FTextBtn
                  onClick={() => {
                    onEdit();
                  }}
                >
                  <FIcons.FEdit style={{ fontSize: 12 }} />
                </FComponentsLib.FTextBtn>
              </div>
            </FTooltip>
          </>
        )}
      </Space>
    );
  }

  return (
    <div>
      <Space size={10}>
        <FInput_PinyinSafeTextCounter
          lengthLimit={-1}
          className={styles.FInput}
          style={{ width: 440 }}
          value={$value}
          onChangeValue={(value) => {
            set$value(value);
            set$valueError(
              value === '' ? '请输入标题' : value.length > 100 ? '不能超过100个字符' : '',
            );
          }}
          placeholder={'请输入标题'}
          hasError={$valueError !== ''}
        />
        <FComponentsLib.FRectBtn
          type={'primary'}
          disabled={$value === '' || $valueError !== ''}
          onClick={() => {
            onOK(get$value());
            set$isEdit(false);
          }}
        >
          {FI18n.i18nNext.tAuto('edit_exhibit_btn_save_title')}
        </FComponentsLib.FRectBtn>
        <FComponentsLib.FRectBtn
          type='default'
          onClick={() => {
            set$isEdit(false);
          }}
        >
          {FI18n.i18nNext.tAuto('edit_exhibit_btn_cancel')}
        </FComponentsLib.FRectBtn>
      </Space>

      {$valueError !== '' && (
        <>
          <div style={{ height: 5 }} />
          <div style={{ color: '#EE4040' }}>{$valueError}</div>
        </>
      )}
    </div>
  );
}
